//@ts-check
import React from "react"
import { useTranslation } from "react-i18next"

import ComboBox from "./combo-box"
import { getFileContracts } from "../utils/get-file-contract"
const CONSTS = require("shared/consts")

/** @typedef {scr.file} file*/
/** @typedef {import('typescript').JsxElement} JSX */
/** @typedef {import("../../../backend/interfaces").dir} dir */
/** @typedef {import("../../../backend/interfaces").dirOrFile} dirOrFile */

/**
 * @param object {{
 * files: file[],
 * setMainFile,
 * mainFile
 * mainContract,
 * setMainContract,
 * }}
 */
export default function ContractsSelector({
  files,
  mainContract,
  mainFile,
  setMainFile,
  setMainContract,
}) {
  const { t } = useTranslation()
  var contracts = []
  for (var file of files) {
    const fileContracts = getFileContracts(file.content).asArray
    fileContracts.forEach(element => {
      contracts.push({
        file: file.path || "",
        name: element || "",
      })
    })
  }

  // filter out empty files, e.g. those containing no contracts
  const validContracts = contracts.filter(option => option.name && option.file)
  const options = validContracts.map(({ name, file }) => ({
    title: name,
    name,
    fullpath: file,
    heading: file.split("/").join(" > "),
  }))

  const getOptionLabel = item => item.title
  // console.log('contractselector',{options,mainContract})
  return (
    <div
      css={`
        label {
          transition: none !important;
        }
        legend {
          transition: none !important;
        }
      `}
    >
      <ComboBox
        options={options}
        onChange={(_event, value, _reason) => {
          setMainContract(value?.title)
          setMainFile(value?.fullpath)
        }}
        value={options.find(contract => {
          return (
            contract?.title === mainContract && contract?.fullpath === mainFile
          )
        })}
        label={t("smart_contract_to_deploy")}
        width={CONSTS.FILE_BROWSER_WIDTH}
        optionsInView={3.7}
        optionHeight={56}
        getOptionLabel={getOptionLabel}
        filterConfig={{ stringify: getOptionLabel }}
      />
    </div>
  )
}
